import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { ResponsiveMode } from '../../../models/responsive-mode.type';
import { SassHelperComponent } from '../../../providers/sass-helper/sass-helper.component';
import {WorkSpaceService} from '../../../services/work-space.service';

@Component({
  selector: 'morva-error403',
  templateUrl: './error403.component.html',
  styleUrls: ['./../error.scss'],
})
export class Error403Component implements OnInit {
  responsiveMode: ResponsiveMode;
  private workspaceId: string;
  private sassHelper: SassHelperComponent;

  constructor(private router: Router,
    private workspaceService: WorkSpaceService,
    private breakPointObserver: BreakpointObserver) {
    this.sassHelper = new SassHelperComponent();
    }

  ngOnInit(): void {
    this.workspaceService.getActiveWorkSpaceID().subscribe(workspaceId => this.workspaceId = workspaceId);
    this.breakPointObserver.observe([this.sassHelper.mdMaxWidth]).subscribe(state => {
      if (state.breakpoints[this.sassHelper.mdMaxWidth]) {
        this.responsiveMode = 'md';
      } else {
        this.responsiveMode = 'lg';
      }
    });
  }

  pageBack() {
    this.router.navigate(['/home',this.workspaceId]);
  }
}
